import React from "react";
import { useState, useEffect } from "react";
import useFetch from "../../utils/useFetch";
import { Divider, Grid, Box } from "@mui/material";
import BaseURL from "../../utils/base-uri.json";
import Select from "@mui/material/Select";
import { Chip, Checkbox } from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import MultiSelectAutoComplete from "../MultiSelectAutoComplete";
import { getOrgType } from "../../utils/Token";

export default function ERIClientSelectionContext({
  Secid,
  SubId,
  SectionType,
  SubSectionTypeCondition,
  setShowFormButtons,
  setEriUserResponse,
  pqId,
  setClientIds,
  setSaveButtionHiden,
  ...props
}) {
  const params = new URLSearchParams(window.location.search);
  const PQID = params.get("pqid");
  const [response, setResponse] = useState([]);
  const [selectedId, setselectedId] = useState([]);
  const [selectedValue, setselectedValue] = useState([]);

  const {
    data: resp,
    loading,
    error,
  } = useFetch(
    BaseURL.baseUrl +
    "Prequalification/SectionOrSubSectionDetails?pqId=" +
    pqId +
    "&sectionId=" +
    Secid +
    "&subSectionTypeCondition=ERIClientSelection&sectionType=" +
    SectionType +
    "&subSectionId=" +
    SubId
  ); // TODO: remove localhost arg



  useEffect(() => {
    if (resp?.data) {
      setResponse(resp?.data);
      setShowFormButtons(true);
      setSaveButtionHiden(false);
      props?.setModifiedData({});
      props?.validateAllSubSectionQuestions([]);
    }
  }, [resp]);

  useEffect(() => {
    if (response?.multiClientsList?.length > 0) {
      const allClientValues = response?.multiClientsList?.map((r) => r.value);
      setselectedValue([...allClientValues]);
    }
    if (response?.unlockedClients?.length > 0) {
      const selectedUnlocked = response?.unlockedClients?.filter(
        (ele) => ele.selected == true
      );
      if (selectedUnlocked?.length == response?.unlockedClients?.length) {
        setSelectAllChecked(true);
      }
      setselectedId(selectedUnlocked);
      setClientIds(selectedUnlocked);
    setEriUserResponse({
      unLockedClients: selectedUnlocked,
      lockedClients: response?.multiClientsList,
    });

    }
  }, [response]);

  const [selectAllChecked, setSelectAllChecked] = useState(false);

  const handleSelectAllChangeNew = (e) => {
    handleSelectChange(e);
  };

  function handleSelectChange(e) {
    const updatedSelected = e?.includes("selectAll")
      ? e?.filter((val) => val !== "selectAll")
      : e;

    setSelectAllChecked(
      updatedSelected?.length === response?.unlockedClients?.length &&
      updatedSelected?.length > 0
    );
    const dataId = typeof e === "string" ? e.split(",") : e;
    setselectedId(dataId);
    setClientIds(dataId);
    setEriUserResponse({
      unLockedClients: dataId,
      lockedClients: response?.multiClientsList,
    });
    // const dataid = e.map((r) => r.value);
    // setselectedValue(dataid);
  }
  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };
  return (
    <>
      <Box sx={{ padding: "20px" }}>
        <Grid
          hidden={getOrgType() == "Client"}
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
          sx={{ marginTop: "50rem" }}
        >
          <Grid item xs={12} sm={12} md={5}>
            <p>Type the client name your company will prequalify for <sup style={{ color: "var(--red50)" }}>*</sup></p>
            {/* <p>OR</p>
            <p>Enter code provided in email: <sup style={{ color: "var(--red50)" }}>*</sup></p> */}
          </Grid>
          <Grid item xs={12} sm={12} md={5}>
            <MultiSelectAutoComplete
              pqId={pqId}
              selectedIds={selectedId}
              onSelectedChange={handleSelectAllChangeNew}
            />
          </Grid>

        </Grid>
        <Divider
          sx={{
            marginTop: 2,
            marginBottom: 2,
            backgroundColor: "#667085;",
            height: "2px",
          }}
          hidden={getOrgType() == "Client"}
        />
        <p style={{ color: "var(--red50)" }} hidden={getOrgType() == "Client"}>
          Sites have been added in Location/Sites Tab. If you want to remove
          these client(s) from Prequalification, Please remove them first in
          Locations/Sites:<br></br>
        </p>
        <ul>
          {selectedValue?.map((selectedItem) => (
            <li key={selectedItem}>{selectedItem}</li>
          ))}
        </ul>
      </Box>
    </>
  );
}
